import { Modal, Form, Table, Input, Checkbox, Button, Space, Typography, notification } from 'antd';
import React, { useMemo } from 'react';
import UserDetailDTO from '../../models/UserDetailDTO';
import UserApiService from 'src/api/UserApiService';
import UpdatePremierPlusNotificationsRequestDTO from 'src/models/UpdatePremierPlusNotificationsRequestDTO';
import UserEmailPhoneNumber from './UserEmailPhoneNumber';
import AutomationType from 'src/consts/AutomationType';

const { Text } = Typography;

interface UserPremierPlusAlertsSettingsModalProps {
  open: boolean;
  user: UserDetailDTO;
  onClose: () => void;
}

const UserPremierPlusAlertsSettingsModal: React.FC<UserPremierPlusAlertsSettingsModalProps> = ({ open, user, onClose }) => {
  const [form] = Form.useForm<UpdatePremierPlusNotificationsRequestDTO>();

  const initialValues = useMemo<UpdatePremierPlusNotificationsRequestDTO>(
    () => ({
        userId: user?.id ?? 0,
        emails: user?.emails ?? [],
        phoneNumbers: user?.phoneNumbers ?? []
    }),
    [user]
  );

  const handleClose = () => {
    onClose();
  };

  const onFinish = async (values: UpdatePremierPlusNotificationsRequestDTO) => {
    try{
        const request : UpdatePremierPlusNotificationsRequestDTO = {
            userId: user.id,
            emails: values.emails ?? [],
            phoneNumbers: values.phoneNumbers ?? []
        }
        const result = await UserApiService.updatePremierPlusNotifications(request);
        onClose();
    }catch(err){
        notification.error({ message: 'Could not update Apex notifications' });
        onClose();
    }
  };

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      title="Apex Alert Settings"
      width={760}
      destroyOnClose
      okText="Submit"
      cancelText="Cancel"
      onOk={() => form.submit()}
    >
      <Form<UpdatePremierPlusNotificationsRequestDTO> form={form} layout="vertical" initialValues={initialValues} onFinish={onFinish}>
        <Form.Item hidden name="userId" />
        <UserEmailPhoneNumber automationType={AutomationType.PremierPlus}/>
      </Form>
    </Modal>
  );
};

export default UserPremierPlusAlertsSettingsModal;
